<template>
	<div class="risolto-timeline block">
		<el-timeline>
			<template v-for="(item, index) of timelineItemComponents">
				<el-timeline-item
					:key="index"
					:icon="item.channel | timelineIconFilter"
					:type="item.type"
					:color="item.color"
					size="xxlarge"
					:timestamp="timestampGenerator(item)"
					placement="top"
				>
					<template #dot>
						<div class="icon-stack" >
							<span class="dot"></span>
							<svg-icon style="font-size: 30px;" :icon-class="item.channel | timelineIconFilter" class="icon"> </svg-icon>
						</div>
					</template>
					<component :is="item.component" :key="index" :item="item" />
				</el-timeline-item>
			</template>
		</el-timeline>
		<div v-if="showLoadMore" class="text-center">
			<span class="loadMoreSpan" @click="loadMore"> {{ $t('loadMore') }}...<i class="el-icon-view el-icon--right" /> </span>
		</div>
		<div v-else class="text-center">
			<p>
				<i>{{ $t('thatsAll') }}</i>
			</p>
		</div>
	</div>
</template>

<script>
import { format } from 'date-fns';
import { nl, fr, enGB } from 'date-fns/locale';
import Action from '@/components/Timeline/Action.vue';
import Dispute from '@/components/Timeline/Dispute.vue';
import Note from '@/components/Timeline/Note.vue';
import Message from '@/components/Timeline/Message.vue';

const locales = { nl, fr, enGB };

export default {
	props: {
		showLoadMore: Boolean,
		timelineItems: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	computed: {
		timelineItemComponents() {
			return this.timelineItems.filter(this.isNoPhoneItem).map(item => {
				if (this.isAction(item)) {
					return {
						...item,
						component: Action
					};
				} else if (this.isNote(item)) {
					return {
						...item,
						component: Note
					};
				} else if (this.isDispute(item)) {
					return {
						...item,
						component: Dispute
					};
				} else if (this.isMessage(item)) {
					return {
						...item,
						component: Message
					};
				} else {
					return {
						...item,
						component: null
					};
				}
			});
		}
	},
	methods: {
		customFormatter(value) {
			return format(new Date(value), 'eeee, d MMMM yyyy - HH:mm', { locale: locales[this.$i18n.locale] ?? enGB });
		},
		timestampGenerator(item) {
			if (this.isNote(item)) {
				return this.customFormatter(item.created_at);
			} else if (this.isDispute(item)) {
				return this.customFormatter(item.updated_at);
			} else if (this.isMessage(item)) {
				return this.customFormatter(item.created_at);
			} else if (item.status && item.status === 'CANCELED') {
				if (item.canceled_at) {
					return this.customFormatter(item.canceled_at);
				} else {
					return this.customFormatter(item.updated_at);
				}
			} else if (item.status && item.status === 'DONE') {
				return this.customFormatter(item.updated_at);
			} else if (item.status && item.status === 'PROCESSING') {
				return this.customFormatter(item.updated_at);
			} else {
				return this.$t('noDatePresent');
			}
		},
		loadMore() {
			this.$emit('loadMore', {});
		},
		isNote(item) {
			return item.note !== null && item.invoice_dispute === null && (item.note_by_reference.action_by_reference ? this.isNoPhoneItem(item) : true);
		},
		isAction(item) {
			return item.action_by_reference !== null;
		},
		isDispute(item) {
			return item.invoice_dispute !== null;
		},
		isPhoneItem(item) {
			return item?.note_by_reference?.action_by_reference?.channel === 'PHONE';
		},
		isNoPhoneItem(item) {
			return !this.isPhoneItem(item);
		},
		isMessage(item) {
			return item.message_by_reference !== null;
		}
	}
};
</script>

<style lang="scss" scoped>

	@import "@/styles/element-variables.scss";
	@import "@/styles/variables.scss";

	$icon-size: 30px;

	.el-timeline {
		padding-left: 10px;
	}

	.icon-stack {

		height: $icon-size;
		width: $icon-size;
		transform: translateX(-10px);

		* {
			position: absolute;
			left: 0;
			top: 0;
		}
	}

	.icon {
		height: $icon-size;
		width: $icon-size;
		padding: 7px;
		color: white;
	}

	.dot {
		height: $icon-size;
		width: $icon-size;
		background-color: $--color-primary;
		border-radius: 50%;
		display: inline-block;
	}

	.timelineitem {
		margin-bottom: -8px;
	}

	.el-timeline-item {
		padding-bottom: 8px !important;
	}

</style>
